const eventEmitter = require('events');

class EventEmitter extends eventEmitter {}

export default new EventEmitter();